import Link from 'next/link';
import { FB_LINK, IG_LINK, TWITTER_LINK, YT_LINK } from '@/constants/apiConstant';

import Button from '../ui/components/Button';
import SubscribeComponent from '../common/components/SubscribeComponent';

export default function NewsSidebar({ title = 'Stay Connected' }: Readonly<{ title?: string }>) {
  const socialLinks = [
    {
      id: 1,
      label: 'Followers',
      count: '15k+',
      href: FB_LINK,
      bgColor: 'bg-[#4281FF]',
      textColor: 'text-white',
    },
    {
      id: 2,
      label: 'Followers',
      count: '1.5k+',
      href: IG_LINK,
      bgColor: 'bg-[#C23785]',
      textColor: 'text-white',
    },
    {
      id: 3,
      label: 'Subscribers',
      count: '8.4k+',
      href: YT_LINK,
      bgColor: 'bg-[#EF5043]',
      textColor: 'text-white',
    },
    {
      id: 4,
      label: 'Followers',
      count: '4.4k+',
      href: TWITTER_LINK,
      bgColor: 'bg-[#42C0F5]',
      textColor: 'text-white',
    },
  ];

  return (
    <div className="flex h-fit w-full flex-col gap-6 md:w-72">
      <div>
        <h6 className="border-b border-gray-400 pb-3 font-inter text-lg font-medium">{title}</h6>
        <div className="mt-4 grid grid-cols-2 gap-4">
          {socialLinks.map(({ id, count, label, href, bgColor, textColor }) => (
            <SocialButton
              key={id}
              count={count}
              type={label}
              href={href}
              backgroundColor={bgColor}
              textColor={textColor}
            />
          ))}
        </div>
      </div>

      <SubscribeComponent/>
    </div>
  );
}

const SocialButton = ({
  count,
  type,
  backgroundColor,
  textColor,
  href,
}: {
  count: string;
  type: string;
  backgroundColor: string;
  textColor: string;
  href: string;
}) => (
  <Link
    href={href}
    target="_blank"
    rel="noopener noreferrer nofollow"
    className={`flex items-center gap-2 rounded-lg p-4 ${backgroundColor} ${textColor}`}
  >
    <div className="flex-1">
      <p className="font-serif text-base">{count}</p>
      <p className="font-sans text-sm">{type}</p>
    </div>
  </Link>
);
